import { Link } from "react-router-dom";
import MarketingNav from "@/components/MarketingNav";
import MarketingFooter from "@/components/MarketingFooter";

// Canonical sub-processor list. Keep in sync with the DPA (Annex III) and the
// Privacy Policy §4. Referenced from both as xpert.company/legal/subprocessors.
const SUBPROCESSORS = [
  ["Stripe, Inc.", "Payments, KYC/identity, Connect payouts", "US / EU / IN"],
  ["Razorpay Software Pvt Ltd", "Payments (India)", "IN"],
  ["Daily.co (Pluot Labs, Inc.)", "Video sessions, recording, transcription", "US / EU"],
  ["Supabase, Inc.", "Database, authentication, file storage", "US / EU"],
  ["Fly.io, Inc.", "Application hosting", "US / multi-region"],
  ["Google LLC", "OAuth sign-in; Calendar & Gmail (only if you connect them)", "US / EU"],
  ["Resend (Plus Five Five, Inc.)", "Transactional email", "US"],
  ["PostHog, Inc.", "Product analytics (consent-gated)", "US"],
  ["Functional Software, Inc. (Sentry)", "Error & performance monitoring", "US"],
  ["Anthropic, PBC", "AI processing — agent reasoning, summaries (zero-retention)", "US"],
  ["OpenAI, LLC", "Embeddings, transcription fallback (zero-retention)", "US"],
];

export default function SubprocessorsPage() {
  return (
    <div className="min-h-screen bg-canvas">
      <MarketingNav />
      <main className="max-w-3xl mx-auto px-5 py-16">
        <Link to="/privacy" className="text-sm text-brand-green hover:text-brand-greenHover">← Privacy Policy</Link>
        <h1 className="font-display text-4xl mt-4 mb-3">Sub-processors</h1>
        <p className="text-slateline-600 leading-relaxed mb-8">
          These are the third parties that process personal data on our behalf to run
          xpert.company, as referenced in our{" "}
          <Link to="/privacy" className="text-brand-green underline hover:no-underline">Privacy Policy</Link> and{" "}
          <Link to="/legal/dpa" className="text-brand-green underline hover:no-underline">Data Processing Addendum</Link>.
          We give enterprise customers 30 days' notice of any change to this list.
        </p>
        <div className="overflow-x-auto border border-slateline-200 rounded-md">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-canvas-card text-left">
                <th className="p-3 font-semibold">Sub-processor</th>
                <th className="p-3 font-semibold">Purpose</th>
                <th className="p-3 font-semibold whitespace-nowrap">Region</th>
              </tr>
            </thead>
            <tbody>
              {SUBPROCESSORS.map(([name, purpose, region]) => (
                <tr key={name} className="border-t border-slateline-100">
                  <td className="p-3 font-medium text-ink">{name}</td>
                  <td className="p-3 text-slateline-600">{purpose}</td>
                  <td className="p-3 text-slateline-500 whitespace-nowrap">{region}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-slateline-500 mt-6">
          Questions about a sub-processor? Contact{" "}
          <a href="mailto:privacy@xpert.company" className="text-brand-green underline hover:no-underline">privacy@xpert.company</a>.
        </p>
      </main>
      <MarketingFooter />
    </div>
  );
}
